// extracted by mini-css-extract-plugin
export default {"brPhone":"400","brPhoneWide":"480","brPhablet":"560","brTabletSmall":"640","brTablet":"768","brTabletWide":"1024","brDesktop":"1248","brDesktopWide":"1440"};